import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "./Card";
import InfoModal from "./InfoModal";
import { fallbackCardByType } from "./CardsGeneral";
import SVG from "../../../Components/SVG";
import { API_BASE_URL } from "../../../config/api";
import useInfinitePaginated, { mergeBuckets } from "../../../hooks/useInfinitePaginated";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";

const EMPTY_CERTIFICATES = { gained: [], remained: [] };
const mergeCertificates = mergeBuckets(["gained", "remained"], (certificate) => certificate?.id ?? certificate?.uuid);

export default function CardsForYou() {
  const navigate = useNavigate();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoModalData, setInfoModalData] = useState(null);
  const { data, initialLoading: isLoading, loadingMore, error, hasNext, sentinelRef, retry } = useInfinitePaginated({ endpoint: `${API_BASE_URL}certificates/certificates`, navigate, initialData: EMPTY_CERTIFICATES, select: (response) => response.results || EMPTY_CERTIFICATES, merge: mergeCertificates });
  const cards = useMemo(() => data.gained.map((certificate) => {
    const fallbackCard = fallbackCardByType[certificate.certificate_type] || {};
    return { ...fallbackCard, ...certificate, key: `gained-${certificate.id}`, title: fallbackCard.title || certificate.certificate_type, imageSrc: certificate.file, downloadUrl: certificate.file, isForExplanation: false, isAchieved: false, isLock: false, isBlured: false };
  }), [data.gained]);

  return (
    <div className="relative w-full">
      {!isLoading && cards.length > 0 && (
        <div className="w-full rounded-2xl p-5 grid grid-cols-1 lg:grid-cols-2 gap-12 justify-items-center bg-zi-bg2-light dark:bg-zi-bg2-dark">
          {cards.map((item) => <Card key={item.key} {...item} onHelp={() => { setInfoModalData(item); setShowInfoModal(true); }} />)}
          <InfiniteScrollFooter sentinelRef={sentinelRef} loading={loadingMore} error={error} onRetry={retry} hasNext={hasNext} />
        </div>
      )}
      {!isLoading && cards.length === 0 && (
        <div className="w-full h-full flex flex-col items-center justify-center gap-4 text-zi-text-light dark:text-zi-text-dark">
          <SVG name="noCertificate" classname="size-32 sm:size-48" />
          <span className="text-center font-normal text-sm sm:text-base text-zi-text-light dark:text-zi-text-dark"><p className="font-medium text-base sm:text-lg">فعلا گواهی‌نامه‌ای ندارید.</p><p className="text-zi-text-light/75 dark:text-zi-text-dark/75">جهت مشاهده لیست گواهی‌نامه‌ها و نحوه دریافت آن‌ها بخش معرفی گواهی‌نامه‌ها را مطالعه کنید.</p></span>
        </div>
      )}
      {showInfoModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={() => setShowInfoModal(false)}>
          <div className="w-11/12 max-w-2xl" onClick={(event) => event.stopPropagation()}><InfoModal title={infoModalData?.title} infoText={infoModalData?.infoText} onClose={() => { setShowInfoModal(false); setInfoModalData(null); }} /></div>
        </div>
      )}
    </div>
  );
}
